// extracted by mini-css-extract-plugin
export var modal = "_bp-0";